import { AppConst } from 'constants/appConst';
import { AppHelper } from 'helpers/appHelper';
import { useRecoilState } from 'recoil';
import { AcctState } from 'stores/atoms/acctState';

export default function CommonWsLayoutNavbarPlan(): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const [acctState] = useRecoilState(AcctState);

  /* ----------------------------------------------------------------------- */
  /* ライフサイクル関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <div className="progress-bar-container">
      <p className="lead">利用状況</p>

      <ul className="list-unstyled list-progress">
        <li>
          <div className="progress-detail">
            <span>コンテンツ公開数</span>
            <span>{acctState.usage.publishedCount} / 100</span>
          </div>
          <div
            className="progress"
            role="progressbar"
            aria-valuenow={75}
            aria-valuemin={0}
            aria-valuemax={100}
          >
            <div
              className="progress-bar"
              style={{
                width: `${AppHelper.formatRateToPercent(acctState.usage.publishedCount, 100)}%`,
              }}
            ></div>
          </div>
        </li>

        <li>
          <div className="progress-detail">
            <span>獲得リスト数</span>
            <span>{acctState.usage.report.total.mailAddressCount} / 1500</span>
          </div>
          <div
            className="progress"
            role="progressbar"
            aria-valuenow={75}
            aria-valuemin={0}
            aria-valuemax={100}
          >
            <div
              className="progress-bar"
              style={{
                width: `${AppHelper.formatRateToPercent(
                  acctState.usage.report.total.mailAddressCount,
                  1500
                )}%`,
              }}
            ></div>
          </div>
        </li>
      </ul>

      <a href={AppConst.url.upgrade} className="btn btn-progress d-block mx-auto">
        アップグレード
      </a>
    </div>
  );
}
